import Alpine from 'alpinejs';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const STUDY_SITES = [
  {
    id: 'colorado',
    name: 'University of Colorado Anschutz School of Medicine',
    city: 'Denver, Colorado',
    lat: 39.745,
    lng: -104.838,
    address: 'Denver, Colorado, United States, 80045',
    contacts: [
      { name: 'Jon Rice, MD' },
      {
        name: 'Malory Truelson',
        phone: '303-724-9143',
        email: 'Mallory.truelson@cuanschutz.edu',
      },
    ],
  },
  {
    id: 'yale',
    name: 'Yale University School of Medicine',
    city: 'New Haven, Connecticut',
    lat: 41.305,
    lng: -72.936,
    address: 'New Haven, Connecticut, United States, 06519',
    contacts: [
      { name: 'Michael Schilsky, MD' },
      {
        name: 'Cameron Groshek, MS, CCRP',
        phone: '203-737-7683',
        email: 'Cameron.groshek@yale.edu',
      },
    ],
  },
  {
    id: 'michigan',
    name: 'University of Michigan Medical Center',
    city: 'Ann Arbor, Michigan',
    lat: 42.281,
    lng: -83.731,
    address: 'Ann Arbor, Michigan, United States, 48109-2029',
    contacts: [
      { name: 'Fred Askari, MD' },
      {
        name: 'Ashley Page',
        phone: '734-998-9966',
        email: 'ashpage@med.umich.edu',
      },
    ],
  },
];

function createSiteMarkerIcon() {
  return L.divIcon({
    className: 'site-map-marker',
    html: '<span class="site-map-marker__pin" aria-hidden="true"></span>',
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

function updateMarkerStates(component) {
  Object.entries(component.markers).forEach(([id, marker]) => {
    const element = marker.getElement();
    if (!element) return;

    const isActive = component.hover === id || component.open === id;
    element.classList.toggle('is-active', isActive);
  });
}

Alpine.data('siteMap', () => ({
  sites: STUDY_SITES,
  open: null,
  hover: null,
  map: null,
  markers: {},

  init() {
    this.$nextTick(() => {
      this.initMap();
      this.$watch('hover', () => updateMarkerStates(this));
      this.$watch('open', () => updateMarkerStates(this));
    });
  },

  initMap() {
    const mapElement = this.$refs.map;
    if (!mapElement || this.map) return;

    this.map = L.map(mapElement, {
      scrollWheelZoom: false,
      zoomControl: true,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18,
    }).addTo(this.map);

    const bounds = L.latLngBounds([]);

    this.sites.forEach((site) => {
      const marker = L.marker([site.lat, site.lng], {
        icon: createSiteMarkerIcon(),
      }).addTo(this.map);

      marker.on('mouseover', () => this.setHover(site.id));
      marker.on('mouseout', () => this.setHover(null));
      marker.on('click', () => this.toggle(site.id));

      this.markers[site.id] = marker;
      bounds.extend([site.lat, site.lng]);
    });

    this.map.fitBounds(bounds, { padding: [40, 40] });
    updateMarkerStates(this);
  },

  setHover(id) {
    this.hover = id;
  },

  toggle(id) {
    this.open = this.open === id ? null : id;

    this.$nextTick(() => {
      if (this.open === id) {
        document.getElementById(`site-item-${id}`)?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    });
  },

  isHighlighted(id) {
    return this.hover === id || this.open === id;
  },
}));

window.Alpine = Alpine;
Alpine.start();
